import { findSubjectByMasterSubjectId } from 'legacy-src/components/learnosity/utils/helpers';
import {
  HIDE_DIGITAL_ASSESSMENT_INFO_MODAL,
  ATTESTATION_SUBJECT,
} from 'legacy/src/constants/types';
import {
  TEACHER_AUTHORED,
  PPC,
  PE,
} from 'chameleon-src/components/assignments/constants';
import { getCourseType } from './constants';

// For Admin or Coords we dont check per subject, we just check if the preference exists
export const getHideAssessmentInfoModalPreferenceAdminOrCoord = (
  userPreferences,
) => {
  const hideAssessmentInfoModalPreference = userPreferences?.find(
    (preference) =>
      preference.preference === HIDE_DIGITAL_ASSESSMENT_INFO_MODAL,
  );
  return !!hideAssessmentInfoModalPreference;
};

export const displayDigitalAssessmentInfoModal = ({
  subject, // coming from router.params
  bluebookUIFF,
  userPreferences,
  userSubjects,
  assesmentType,
  isStudent,
  subjectData, // for students
  isCoTaught, // for teachers,
}) => {
  let shouldDisplayDigitalAssessmentInfoModal;
  const isMyQuiz =
    assesmentType === TEACHER_AUTHORED || isCoTaught || assesmentType === '';

  const isPPC = assesmentType === PPC;
  const isPE = assesmentType === PE;

  const subjectInfo = isStudent
    ? subjectData
    : findSubjectByMasterSubjectId(userSubjects, subject);

  const subjectId = parseInt(subject, 10);

  const courseType = getCourseType(subjectId);

  if (!courseType) {
    return false; // NOT AP course
  }

  const getHideAssessmentInfoModalPreference = () => {
    const hideAssessmentInfoModalPreference = userPreferences?.find(
      (preference) =>
        preference.preference === HIDE_DIGITAL_ASSESSMENT_INFO_MODAL &&
        preference.context === ATTESTATION_SUBJECT &&
        preference.contextId === subjectInfo?.initId,
    );
    return !!hideAssessmentInfoModalPreference;
  };

  if (!!assesmentType) {
    shouldDisplayDigitalAssessmentInfoModal =
      bluebookUIFF &&
      (isMyQuiz || isPPC || isPE) &&
      !getHideAssessmentInfoModalPreference();
  } else {
    shouldDisplayDigitalAssessmentInfoModal =
      bluebookUIFF && !getHideAssessmentInfoModalPreference(); // if we dont pass assesmentType, we assume this is QB, PPC, PE
  }

  return shouldDisplayDigitalAssessmentInfoModal;
};
